/**
 * Created by dev on 2020/9/24.
 */
import Vue from 'vue'
//仅汉字
Vue.directive('onlyCN',{
  bind(el, binding, vnode) {
    const element = el;
    var res='';
    element.addEventListener('keyup', function() {
      var value=element.value;
      res=value.replace(/[^\u4E00-\u9FA5]/g,'')
      el.value = res;
    });
  }
})

//仅多少位数
Vue.directive('lenLimit',{
  bind(el, binding, vnode) {
    const element = el;
    var res='';
    element.addEventListener('keyup', function() {
      var value=element.value+'';
      var len=element.getAttribute('maxlength');
      if(value.length>len){
        res=value.substring(0,len)
      }else{
        res=value
      }
      el.value = res;
    });
  }
})

//只能输入数字
Vue.directive('onlyInteger', {
  bind(el, binding, vnode) {
    const element = el;
    var res='';
    element.value = Number(element.value);
    element.addEventListener('keyup', function() {
      res=element.value.replace(/\D/g,'')
      el.value = res;
    });
  }
})

//只能输入数字和小数点
Vue.directive('IntToF2',{
  bind(el, binding, vnode) {
    const element = el;
    element.addEventListener('keyup', function() {
      var str = element.value;
      var len1 = str.substr(0, 1);
      var len2 = str.substr(1, 1);
      //如果第一位是0，第二位不是点，就用数字把点替换掉
      if (str.length > 1 && len1 == 0 && len2 != ".") {
        str = str.substr(1, 1);
      }
      //第一位不能是.
      if (len1 == ".") {
        str = "";
      }
      //限制只能输入一个小数点
      if (str.indexOf(".") != -1) {
        var str_ = str.substr(str.indexOf(".") + 1);
        if (str_.indexOf(".") != -1) {
          str = str.substr(0, str.indexOf(".") + str_.indexOf(".") + 1);
        }
      }
      //正则替换，保留数字和小数点
      str = str.replace(/[^\d^\.]+/g,'')
      //如果需要保留小数点后两位，则用下面公式
      //str = str.replace(/\.\d\d$/,'')

      el.value = res;
    });
  }
})
//只能输入正整数
Vue.directive('positiveInt',{
  bind(el, binding, vnode) {
    const element = el;
    var res='';
    element.value = Number(element.value);
    element.addEventListener('keyup', function() {
      if(this.value.length==1){
        res=element.value.replace(/[^1-9]/g,'')
      }else{
        res=element.value.replace(/\D/g,'')
      }
      el.value = res;
    });
  }
})



// WEBPACK FOOTER //
// ./src/directive/index.js